import React from 'react';
import _ from 'lodash';

import { useCustomerChatWidgetQuery } from 'generated/graphql';
import { ChatMessageList } from 'modules';
import { DateTime } from 'luxon';



export interface IData {
  chatMessages: ChatMessageList.IMessage[];
}

export function useQuery(id: string, queryOrder: boolean) {
  const tuple = useCustomerChatWidgetQuery({
    variables: {
      id,
      queryOrder
    }
  });

  return React.useMemo(
    () => {
      const nodes = queryOrder
        ? tuple.data?.orderLite?.messages.nodes
        : tuple.data?.returnAuthorizationLite?.messages.nodes;

      const data: IData = {
        chatMessages: _.map(nodes ?? [], (node): ChatMessageList.IMessage => ({
          id: node.id,
          content: node.content,
          metaCreated: DateTime.fromISO(node.metaCreated),
          senderUserName: node.senderName
        }))
      };

      return {
        ...tuple,
        data
      };
    },
    [
      queryOrder,
      tuple
    ]
  );
}
